export function formatDate(dateInput) {
  const meses = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  const dia = date.getDate().toString().padStart(2, "0");
  const mes = meses[date.getMonth()];
  const ano = date.getFullYear();
  return `${dia} ${mes} ${ano}`;
}
